import * as React from 'react';
import { GeneralSiteSettingsSubspaceState } from '../../../app/spaces/SiteSettingsSpace/GeneralSiteSettingsSubspace';
import { Messages } from '../../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { ToasterService, ToastType } from '../../../ts/services/ToasterService';
import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import ReactSiteSettingsForServerAdmin from './ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from './ReactSiteSettingsForSiteAdminSubFormik';

/**
 * Creates a settings coordinator with the site settings for site admin and site settings for server admin forms
 */
export function GeneralSettingsCoordinator(props: GeneralSiteSettingsSubspaceState) {
  const sessionManagementService = getSessionManagementServiceInstance();

  const shouldRenderServerAdminForm = sessionManagementService.isSessionServerAdmin();
  const shouldRenderSiteAdminForm = sessionManagementService.isSessionServerAdmin()
    || (sessionManagementService.isSessionSiteAdmin() && sessionManagementService.isOnlineEnvironment());

  // const sections = useMemoizedConditionalGeneralSections();
  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}>

      {shouldRenderServerAdminForm &&
      <ReactSiteSettingsForServerAdmin settings={props}/>}

      {shouldRenderSiteAdminForm &&
      <ReactSiteSettingsForSiteAdmin settings={props}/>}

    </SettingsCoordinator>
  );
}

/**
 * This is called after all registered forms resolve their submit promises successfully
 */
async function coordinatorSubmitHandler() {
  // Pop the toast depending on results
  ToasterService.instance.pop({type: ToastType.Success, text: Messages.settingsUpdateSuccess()});

  // Refresh session info as some data may have changed after saving settings
  await getSessionManagementServiceInstance().refreshSessionInfo();
}

/**
 * If a subform throws an array, assume each entry is a message for a new error toast message.
 * Otherwise show a generic error message
 * @param error - An error message or an array of error messages
 */
async function coordinatorSubmitFailedHandler(error: any) {

  if (Array.isArray(error)) {
    error.forEach(errorMessage => ToasterService.instance.pop({
        type: ToastType.Error,
        text: errorMessage
      }
    ));
  }

  else {
    ToasterService.instance.pop({type: ToastType.Error, text: Messages.settingsUpdateFailure()});
  }
}
